module.exports = __webpack_public_path__ + "img/box6-20.b00c7c5f.png";